export enum UrlPath {
  AUDIO = '/audio',
  PDF_FILES = '/pdffiles',
}
